import React from "react";
import { Slice } from "gatsby";

type ModuleLoaderProps = {
    previewMode?: boolean;
    rerender?: boolean;
    modules: any[];
    language: string;
    defaultLanguage: string;
    destinationId: string;
    suppliers?: any[];
    oldSuppliers?: any[];
    entries?: any[];
    packageData?: any;
    location?: Location;
    mobileModuleSpacer?: boolean;
}



class ModuleLoader extends React.Component<ModuleLoaderProps> {

    static whyDidYouRender = true;

    shouldComponentUpdate(nextProps: Readonly<ModuleLoaderProps>, nextState: Readonly<{}>, nextContext: any): boolean {
        if (nextProps.rerender || this.props.rerender) return true;
        if (nextProps.previewMode) return true;
        if (nextProps.language !== this.props.language) return true;
        if (nextProps.defaultLanguage !== this.props.defaultLanguage) return true;
        if (nextProps.location?.pathname !== this.props.location?.pathname) return true;
        if (nextProps.modules?.length !== this.props.modules?.length) return true;
        return false;
    }

    render() {
        // const modules = this.retrieveModules();
        return <>
            <Slice alias="pagemodule-0"></Slice>
            <Slice alias="pagemodule-1"></Slice>
            <Slice alias="pagemodule-2"></Slice>
            <Slice alias="pagemodule-3"></Slice>
            <Slice alias="pagemodule-4"></Slice>
            <Slice alias="pagemodule-5"></Slice>
            <Slice alias="pagemodule-6"></Slice>
            <Slice alias="pagemodule-7"></Slice>
            <Slice alias="pagemodule-8"></Slice>
            <Slice alias="pagemodule-9"></Slice>
            <Slice alias="pagemodule-10"></Slice>
            <Slice alias="pagemodule-11"></Slice>
            <Slice alias="pagemodule-12"></Slice>
            <Slice alias="pagemodule-13"></Slice>
            <Slice alias="pagemodule-14"></Slice>
            <Slice alias="pagemodule-15"></Slice>
            <Slice alias="pagemodule-16"></Slice>
            <Slice alias="pagemodule-17"></Slice>
            <Slice alias="pagemodule-18"></Slice>
            <Slice alias="pagemodule-19"></Slice>
            <Slice alias="pagemodule-20"></Slice>
            <Slice alias="pagemodule-21"></Slice>
            <Slice alias="pagemodule-22"></Slice>
            <Slice alias="pagemodule-23"></Slice>
            <Slice alias="pagemodule-24"></Slice>
            <Slice alias="pagemodule-25"></Slice>
            <Slice alias="pagemodule-26"></Slice>
            <Slice alias="pagemodule-27"></Slice>
            <Slice alias="pagemodule-28"></Slice>
            <Slice alias="pagemodule-29"></Slice>
            <Slice alias="pagemodule-30"></Slice>
            <Slice alias="pagemodule-31"></Slice>
            <Slice alias="pagemodule-32"></Slice>
            <Slice alias="pagemodule-33"></Slice>
            <Slice alias="pagemodule-34"></Slice>
            <Slice alias="pagemodule-35"></Slice>
            <Slice alias="pagemodule-36"></Slice>
            <Slice alias="pagemodule-37"></Slice>
            <Slice alias="pagemodule-38"></Slice>
            <Slice alias="pagemodule-39"></Slice>
            <Slice alias="pagemodule-40"></Slice>
            <Slice alias="pagemodule-41"></Slice>
            <Slice alias="pagemodule-42"></Slice>
            <Slice alias="pagemodule-43"></Slice>
            <Slice alias="pagemodule-44"></Slice>
            <Slice alias="pagemodule-45"></Slice>
            <Slice alias="pagemodule-46"></Slice>
            <Slice alias="pagemodule-47"></Slice>
            <Slice alias="pagemodule-48"></Slice>
            <Slice alias="pagemodule-49"></Slice>
            <Slice alias="pagemodule-50"></Slice>
            <Slice alias="pagemodule-51"></Slice>
            <Slice alias="pagemodule-52"></Slice>
            <Slice alias="pagemodule-53"></Slice>
            <Slice alias="pagemodule-54"></Slice>
            <Slice alias="pagemodule-55"></Slice>
            <Slice alias="pagemodule-56"></Slice>
            <Slice alias="pagemodule-57"></Slice>
            <Slice alias="pagemodule-58"></Slice>
            <Slice alias="pagemodule-59"></Slice>
            <Slice alias="pagemodule-60"></Slice>
            <Slice alias="pagemodule-61"></Slice>
            <Slice alias="pagemodule-62"></Slice>
            <Slice alias="pagemodule-63"></Slice>
            <Slice alias="pagemodule-64"></Slice>
            <Slice alias="pagemodule-65"></Slice>
            <Slice alias="pagemodule-66"></Slice>
            <Slice alias="pagemodule-67"></Slice>
            <Slice alias="pagemodule-68"></Slice>
            <Slice alias="pagemodule-69"></Slice>
            <Slice alias="pagemodule-70"></Slice>
            <Slice alias="pagemodule-71"></Slice>
            <Slice alias="pagemodule-72"></Slice>
            <Slice alias="pagemodule-73"></Slice>
            <Slice alias="pagemodule-74"></Slice>
            <Slice alias="pagemodule-75"></Slice>
            <Slice alias="pagemodule-76"></Slice>
            <Slice alias="pagemodule-77"></Slice>
            <Slice alias="pagemodule-78"></Slice>
            <Slice alias="pagemodule-79"></Slice>
            <Slice alias="pagemodule-80"></Slice>
            <Slice alias="pagemodule-81"></Slice>
            <Slice alias="pagemodule-82"></Slice>
            <Slice alias="pagemodule-83"></Slice>
            <Slice alias="pagemodule-84"></Slice>
            <Slice alias="pagemodule-85"></Slice>
            <Slice alias="pagemodule-86"></Slice>
            <Slice alias="pagemodule-87"></Slice>
            <Slice alias="pagemodule-88"></Slice>
            <Slice alias="pagemodule-89"></Slice>
            <Slice alias="pagemodule-90"></Slice>
            <Slice alias="pagemodule-91"></Slice>
            <Slice alias="pagemodule-92"></Slice>
            <Slice alias="pagemodule-93"></Slice>
            <Slice alias="pagemodule-94"></Slice>
            <Slice alias="pagemodule-95"></Slice>
            <Slice alias="pagemodule-96"></Slice>
            <Slice alias="pagemodule-97"></Slice>
            <Slice alias="pagemodule-98"></Slice>
            <Slice alias="pagemodule-99"></Slice>
        </>;
    }
}


export default ModuleLoader;
